import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    class: _vm.$style.ManualLink,
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('SIcon', {
    attrs: {
      "icon": "i-hint",
      "size": "20"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };